import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Container from '@mui/material/Container';
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AppState } from 'src/store';
import { Navigate, Route, Routes } from 'react-router-dom'
import { conf } from 'src/config'
import { changePageTitle } from '../../actions'
import Header from '../components/Header';
import PublicMenu from '../menu/PublicMenu';
import NetworkLog from '../components/NetworkLog';
import * as routes from '../../routes';

import UIComponent from '../components/UIComponent';


const DefaultView: React.FC = () => {
    return (
        <>
            {/* <Typography>Dashboard</Typography> */}
        </>
    )
}

const Public: React.FC = () => {
    const dispatch = useDispatch();
    const loginState = useSelector((state: AppState) => state.global.login);
    const location = useSelector((state: AppState) => state.router.location);

    useEffect(() => {
        dispatch(changePageTitle('Index'))
    }, [])

    const rtConf = conf.getUiRoutes();

    return (
        <Container maxWidth={false} sx={{ minHeight: '100vh' }}>
            <Box sx={{ display: 'flex' }}>
                <Header />

                <PublicMenu />

                <Box component="main" sx={{ flexGrow: 1, p: 0, pt: 1 }}>
                    <Toolbar />
                    <Routes>
                        {
                            Object.keys(rtConf)
                                .map((path, index) => {
                                    const routePath: string = path.slice(routes.ROUTEUI.length);
                                    return <Route path={routePath} key={routePath} element={loginState.token == null ? <Navigate to='/login' replace /> : <UIComponent componentConf={rtConf[path].comp} key={routePath} />} />
                                })
                        }
                        <Route path="*" element={<DefaultView />} />
                    </Routes>
                </Box>
                {/* <Link to={{
                    pathname: routes.ROUTEADMIN,
                }}>{'admin console'}</Link> */}

                {/* <NetworkLog /> */}

            </Box>
        </Container>
    )
}

export default Public;
